<template>
  <form @submit.prevent="submit()">
    <b-row>

      <b-col lg="6" sm="12">
        <b-form-group>
          <label for="title">{{ $t('global.title') }}</label>
          <input type="text" id="title" class="form-control" v-model="item.title" :placeholder="$t('global.title')">
          <div v-if="isInvalid('title')" class="text-danger">
            {{ violations.title }}
          </div>
        </b-form-group>
      </b-col>

      <b-col lg="6" sm="12">
        <b-form-group>
          <label for="description">{{ $t('global.description') }}</label>
          <input type="text" id="description" class="form-control" v-model="item.description" :placeholder="$t('global.description')">
          <div v-if="isInvalid('description')" class="text-danger">
            {{ violations.description }}
          </div>
        </b-form-group>
      </b-col>
      <b-col lg="3" sm="3">
        <b-form-group>
          <label for="allowed_domain">{{ $t('views.externalform.form.allowedDomain') }}</label>
          <input type="text" id="allowed_domain" class="form-control" v-model="item.allowedDomain" :placeholder="$t('views.externalform.form.allowedDomain')">
          <div v-if="isInvalid('allowedDomain')" class="text-danger">
            {{ violations.allowedDomain }}
          </div>
        </b-form-group>
      </b-col>
      <b-col lg="3" sm="3">
        <b-form-group>
          <label for="allowed_domain">{{ $t('views.externalform.form.offerExternalAddress') }}</label>
          <input type="text" id="allowed_domain" class="form-control" v-model="item.offerExternalAddress" :placeholder="$t('views.externalform.form.offerExternalAddress')">
          <div v-if="isInvalid('offerExternalAddress')" class="text-danger">
            {{ violations.offerExternalAddress }}
          </div>
        </b-form-group>
      </b-col>
      <b-col sm="6" lg="3">
        <label>{{ $t('views.externalform.form.smsBefore') }}:</label>
        <b-form-group>
          <b-form-radio-group buttons button-variant="outline-primary" id="include_css" v-model="item.smsBefore">
            <b-form-radio button-variant="outline-primary" :value="1">{{$t('buttons.yes')}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="0">{{$t('buttons.no')}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
      <b-col sm="6" lg="3">
        <label>{{ $t('views.externalform.form.smsAfter') }}:</label>
        <b-form-group>
          <b-form-radio-group :disabled="item.actionForExistingAgreement === 2" buttons button-variant="outline-primary" id="include_css" v-model="item.smsAfter">
            <b-form-radio button-variant="outline-primary" :value="1">{{$t('buttons.yes')}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="0">{{$t('buttons.no')}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
      <b-col sm="6" lg="6">
        <label>{{ $t('views.externalform.form.actionForExistingAgreement') }}:</label>
        <b-form-group>
          <b-form-radio-group buttons button-variant="outline-primary" id="include_css" v-model="item.actionForExistingAgreement">
            <b-form-radio button-variant="outline-primary" :value="0">{{$t('views.externalform.form.onlyProposition')}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="1">{{$t('views.externalform.form.onlyAccept')}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="2">{{$t('views.externalform.form.signAndAccept')}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
      <b-col sm="6" lg="6">
        <b-alert class="mt-3" show variant="info">{{$t('views.externalform.form.smsAfterInfo')}}</b-alert>
      </b-col>
      <b-col sm="6" lg="12">
        <label>{{ $t('views.externalform.form.externalFormType') }}:</label>
        <b-form-group>
          <b-form-radio-group buttons button-variant="outline-primary" id="include_css" v-model="item.formType">
            <b-form-radio button-variant="outline-primary" :value="0">{{$t('views.externalform.form.isNotExternalOffer')}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="1">{{$t('views.externalform.form.isExternalOffer')}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="2">{{$t('views.externalform.form.interestedForm')}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <hr class="my-2">
    <b-row>
      <b-col cols="12">
        <h6>{{ $t('views.externalform.form.librarySettings') }}</h6>
      </b-col>
      <b-col sm="6" lg="3">
        <label>{{ $t('views.externalform.form.embedBootstrapCSS') }}:</label>
        <b-form-group>
          <b-form-radio-group buttons button-variant="outline-primary" id="include_css" v-model="item.includeCSS">
            <b-form-radio button-variant="outline-primary" :value="1">{{$t('buttons.yes')}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="0">{{$t('buttons.no')}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>

      <b-col sm="6" lg="3">
        <label>{{ $t('views.externalform.form.embedBootstrapJS') }}:</label>
        <b-form-group>
          <b-form-radio-group buttons button-variant="outline-primary" id="include_js" v-model="item.includeJS">
            <b-form-radio button-variant="outline-primary" :value="1">{{$t('buttons.yes')}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="0">{{$t('buttons.no')}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>

    </b-row>
    <hr class="my-2">
    <b-row>

      <b-col cols="12">
        <h6>{{ $t('views.externalform.form.mailFormSetting') }}</h6>
      </b-col>

      <b-col sm="6" lg="3">
        <label>{{ $t('views.externalform.form.sendEmailToOwner') }}:</label>
        <b-form-group>
          <b-form-radio-group buttons button-variant="outline-primary" id="send_email_to_owner" v-model="item.mailToOwner">
            <b-form-radio button-variant="outline-primary" :value="1">{{$t('buttons.yes')}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="0">{{$t('buttons.no')}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>

      <b-col sm="6" lg="3">
        <label>{{ $t('views.externalform.form.sendEmailToOffice') }}:</label>
        <b-form-group>
          <b-form-radio-group buttons button-variant="outline-primary" id="send_email_to_office" v-model="item.mailToOffice">
            <b-form-radio button-variant="outline-primary" :value="1">{{$t('buttons.yes')}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="0">{{$t('buttons.no')}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>

      <b-col sm="6" lg="3">
        <label>{{ $t('views.externalform.form.sendEmailAfter') }}:</label>
        <b-form-group>
          <b-form-radio-group buttons button-variant="outline-primary" id="send_email_after" v-model="item.sendEmailAfter">
            <b-form-radio button-variant="outline-primary" :value="1">{{$t('buttons.yes')}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="0">{{$t('buttons.no')}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>

      <b-col sm="6" lg="3">
        <label>{{ $t('views.externalform.form.customEmail') }}:</label>
        <b-form-group>
          <b-form-radio-group buttons button-variant="outline-primary" id="is_custom_email" v-model="item.customEmail">
            <b-form-radio button-variant="outline-primary" :value="1">{{$t('buttons.yes')}}</b-form-radio>
            <b-form-radio button-variant="outline-primary" :value="0">{{$t('buttons.no')}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-collapse id="custom_email_collapse" v-model="isEmailContentVisible">
        <b-form-group>
          <label for="custom_email_content">{{ $t('views.externalform.form.emailContent') }}:</label>
          <textarea name="custom_email_content" class="form-control" id="custom_email_content" rows="5"></textarea>
        </b-form-group>
        </b-collapse>
      </b-col>

    </b-row>
    <hr class="my-2">
    <b-row>
      <b-col cols="12">
        <h6>{{ $t('views.externalform.form.afterSignHtml') }}</h6>
      </b-col>
      <b-col cols="12">
        <b-form-group>
          <label for="afterSignHtml">{{ $t('views.externalform.form.afterSignHtml') }}:</label>
          <textarea
            rows="8"
            spellcheck="false"
            style="font-family: 'Consolas'; max-height: 200px;"
            v-model="item.afterSignHtml"
            class="form-control"
            id="htmlContent"
          ></textarea>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <h6>{{ $t('views.externalform.form.agreementSetting') }}</h6>
      </b-col>

      <b-col sm="12" lg="4">
        <b-form-group>
          <label for="document_template">{{ $t('views.externalform.form.documentTemplate') }}</label>
          <model-select ref="test_select" id="document_template" :options="documentTemplateOptions" v-model="item.documentTemplate"></model-select>
          <div
            v-if="isInvalid('documentTemplate')"
            class="invalid-feedback">{{ violations.documentTemplate }}
          </div>
        </b-form-group>
      </b-col>

      <b-col sm="12" lg="4">
        <label for="date_from">{{ $t('global.dateFrom') }}</label>
        <b-form-group>
          <el-date-picker
            :picker-options="{firstDayOfWeek: 1}"
            id="date_from"
            v-model="item.dateFrom"
            type="date"
            :placeholder="$t('global.dateFrom')"
            default-time="12:00:00">
          </el-date-picker>
          <div
            v-if="isInvalid('dateFrom')"
            class="invalid-feedback">{{ violations.dateFrom }}
          </div>
        </b-form-group>
      </b-col>

      <b-col sm="12" lg="4">
        <label for="date_to">{{ $t('global.dateTo') }}</label>
        <b-form-group>
          <el-date-picker
            :picker-options="{firstDayOfWeek: 1}"
            id="date_to"
            v-model="item.dateTo"
            type="date"
            :placeholder="$t('global.dateTo')"
            default-time="12:00:00">
          </el-date-picker>
          <div
            v-if="isInvalid('dateTo')"
            class="invalid-feedback">{{ violations.dateTo }}
          </div>
        </b-form-group>
      </b-col>

    </b-row>
    <hr class="my-2">
    <b-row>
      <b-col cols="12">
        <h6 class="d-inline-block">{{ $t('views.externalform.form.advancedFormSetting') }}</h6>
        <button type="button" class="btn btn-sm mx-2" @click="toggleAdvancedFormSetting()">
          <span v-if="!isAdvancedSettingsVisible">{{ $t('buttons.expand') }}</span>
          <span v-else>{{ $t('buttons.fold') }}</span>
        </button>
      </b-col>
    </b-row>
    <b-collapse id="advanced_settings_collapse" v-model="isAdvancedSettingsVisible">
    <b-row>
      <b-col cols="12">
        <h5><b-badge variant="warning">{{ $t('views.externalform.form.infoScriptData') }}</b-badge></h5>
      </b-col>
      <b-col sm="12" lg="4">
        <b-form-group>
          <label for="after_loaded_script">{{ $t('views.externalform.form.afterLoaded') }}</label>
          <textarea
            v-model="item.afterLoaded"
            name="custom_email_content"
            class="form-control"
            id="after_loaded_script"
            rows="5"
            :placeholder="$t('views.externalform.form.afterLoaded')"
          ></textarea>
        </b-form-group>
      </b-col>
      <b-col sm="12" lg="4">
        <b-form-group>
          <label for="after_posted_script">{{ $t('views.externalform.form.afterPost') }}</label>
          <textarea
            v-model="item.afterPost"
            name="custom_email_content"
            class="form-control"
            id="after_posted_script"
            rows="5"
            :placeholder="$t('views.externalform.form.afterPost')"
          ></textarea>
        </b-form-group>
      </b-col>
      <b-col sm="12" lg="4">
        <b-form-group>
          <label for="custom_css">{{ $t('views.externalform.form.customCss') }}</label>
          <textarea
            v-model="item.customCss"
            name="custom_css"
            class="form-control"
            id="custom_css"
            rows="5"
            :placeholder="$t('views.externalform.form.customCss')"
          ></textarea>
        </b-form-group>
      </b-col>
    </b-row>
    </b-collapse>

    <hr class="my-2">
    <b-row v-if="item.form">
      <b-col cols="12" v-for="(tab, tabIndex) in item.form.tabs" :key="'tab-'+tabIndex" >
<!--        ZAKŁADKA-->
        <b-card>
          <h6 class="d-inline-block"> {{ $t('views.externalform.form.tab') }} - {{ tabIndex + 1 }}</h6>
          <button type="button" class="btn btn-sm mx-2" @click="toggleTab(tabIndex)">
            <span v-if="!tabVisibility[tabIndex].tab">{{ $t('buttons.expand') }}</span>
            <span v-else>{{ $t('buttons.fold') }}</span>
          </button>
          <button
            type="button"
            class="btn btn-link"
            v-b-tooltip.hover :title="$t('buttons.delete')"
            @click="removeTab(tabIndex)">
            <i class="fa fa-trash fa-lg"></i>
          </button>
          <hr class="my-1">

<!--          ELEMENT-->
          <b-collapse v-model="tabVisibility[tabIndex].tab" :id="'tab_collapse_' + tabIndex">
            <b-col cols="12" v-for="(element, elementIndex) in item.form.tabs[tabIndex]" :key="'element-'+elementIndex">
              <b-card>
                <div class="d-inline-block">
                  <h6 class="d-inline-block">
                  {{ $t('views.externalform.form.element') }} - {{ elementIndex + 1 }}
                  </h6>
                </div>
                <div class="d-inline-block">
                  <button
                    v-if="!simpleForms.includes(getSelectedElement(tabIndex, elementIndex))"
                    type="button"
                    class="btn btn-sm mx-2"
                    @click="toggleElement(tabIndex, elementIndex)">
                    <span v-if="!tabVisibility[tabIndex].elements[elementIndex]">{{ $t('buttons.expand') }}</span>
                    <span v-else>{{ $t('buttons.fold') }}</span>
                  </button>
                </div>
                <div class="d-inline-block col-3">
                  <model-select
                    :ref="'select_tab_' + tabIndex + '_element_' + elementIndex"
                    :options="elementOptions"
                    v-model="item.form.tabs[tabIndex][elementIndex].selected"
                    @input="elementSelected({
                      value: $event,
                      tabIndex: tabIndex,
                      elementIndex: elementIndex
                    })"
                  >
                  </model-select>
                </div>
                <div class="d-inline-block">
                  <button
                    type="button"
                    class="btn btn-link"
                    v-b-tooltip.hover :title="$t('buttons.delete')"
                    @click="removeElement(tabIndex, elementIndex)">
                    <i class="fa fa-trash fa-lg"></i>
                  </button>
                </div>
                <div class="d-inline-block" v-if="getSelectedElement(tabIndex, elementIndex) !== 'customForm'">
                  <b-form-checkbox
                    class="ml-4"
                    :value="1"
                    :unchecked-value="0"
                    v-model="item.form.tabs[tabIndex][elementIndex].hasCustomHtmlContent"
                    :id="'checkbox_required_tab_' + tabIndex + '_element_' + elementIndex + 'hasCustomHtmlContent'"
                  >
                  <p class="mt-1">
                    {{$t('views.externalform.form.hasCustomHtmlContent')}}
                  </p>
                  </b-form-checkbox>
                </div>
                <div v-if="getSelectedElement(tabIndex, elementIndex) !== 'customForm' && item.form.tabs[tabIndex][elementIndex].hasCustomHtmlContent === 1">
                  <b-row>
                    <b-col>
                      <textarea
                        rows="10"
                        spellcheck="false"
                        style="font-family: 'Consolas'; max-height: 350px;"
                        v-model="item.form.tabs[tabIndex][elementIndex].htmlContent"
                        class="form-control"
                        id="htmlContent"
                      ></textarea>
                    </b-col>
                  </b-row>
                </div>
                <hr
                  class="my-1"
                  v-if="!simpleForms.includes(getSelectedElement(tabIndex, elementIndex))"
                >
                <b-collapse
                  v-model="tabVisibility[tabIndex].elements[elementIndex]"
                  :id="'tab_collapse_' + tabIndex + 'element_' + elementIndex"
                  v-if="!simpleForms.includes(getSelectedElement(tabIndex, elementIndex))"
                >
                  <template v-if="getSelectedElement(tabIndex, elementIndex) === 'customForm'">
                    <input type="text" :id="'custom_name' + tabIndex + '_element_' + elementIndex" class="form-control mb-2" v-model="item.form.tabs[tabIndex][elementIndex].form.title" :placeholder="$t('global.title')">
                    <textarea
                      rows="10"
                      spellcheck="false"
                      style="font-family: 'Consolas'; max-height: 350px;"
                      v-model="item.form.tabs[tabIndex][elementIndex].form.htmlContent"
                      class="form-control"
                      id="htmlContent"
                    ></textarea>
                  </template>
                  <table class="table table-responsive-md table-sm table-hover table-striped" v-else>
                    <tr v-if="getSelectedElement(tabIndex, elementIndex) === 'customFieldsForm'">
                      <th colspan="50%">
                        <label for="allowed_domain">{{ $t('views.externalform.form.groupName') }}</label>
                        <input type="text" :id="'group_name' + tabIndex + '_element_' + elementIndex" class="form-control" v-model="item.form.tabs[tabIndex][elementIndex].groupName" :placeholder="$t('views.externalform.form.groupName')">
                      </th>
                    </tr>
                    <thead>
                    <tr>
                      <th>{{ $t('views.externalform.form.nameField') }}</th>
                      <th class="text-center"
                          v-if="getTypeOfElement(tabIndex, elementIndex) !== 'select'"
                      >
                        {{ $t('views.externalform.form.requiredField') }}
                      </th>
                      <th v-if="getSelectedElement(tabIndex, elementIndex) === 'customFieldsForm'">
                        {{ $t('views.externalform.form.fieldType') }}
                      </th>
                      <th v-if="getSelectedElement(tabIndex, elementIndex) === 'customFieldsForm'">
                        {{ $t('views.excmtasktype.form.desc2tooltip') }}
                      </th>
                      <th class="text-center">{{ $t('views.externalform.form.displayField') }}</th>
                      <th style="width: 10%">{{ $t('views.externalform.form.orderField') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <!--                  POLE FORMULARZA-->
                    <tr v-for="(field, fieldIndex) in Object.values(item.form.tabs[tabIndex][elementIndex].form)" :key="'field_'+fieldIndex">
                      <td>
                        <b>
                          {{ field.label }}
                        </b>
                        <ul v-if="field.customFieldValues && field.customFieldValues.length > 0">
                          <li v-for="(customFieldValue, customFieldValueIndex) in field.customFieldValues" :key="'customFieldValue_'+customFieldValueIndex">
                            {{ customFieldValue.text }}
                          </li>
                        </ul>
                      </td>
                      <td class="text-center"
                          v-if="getTypeOfElement(tabIndex, elementIndex) !== 'select'">
                        <b-form-checkbox
                          class="d-inline-block"
                          v-model="field.required"
                          :id="'checkbox_required_' + fieldIndex + '_tab_' + tabIndex + '_element_' + elementIndex"
                        ></b-form-checkbox>
                      </td>
                      <td v-if="getSelectedElement(tabIndex, elementIndex) === 'customFieldsForm'">
                        {{ getCustomFieldTypeText(field.type) }}
                      </td>
                      <td v-if="getSelectedElement(tabIndex, elementIndex) === 'customFieldsForm'">
                        <input
                          class="form-control"
                          v-model="field.tooltip"
                          disabled="true"
                          :id="'tooltip_field_' + fieldIndex + '_tab_' + tabIndex + '_element_' + elementIndex"
                          type="text">
                      </td>
                      <td class="text-center">
                        <b-form-checkbox
                          class="d-inline-block"
                          v-model="field.display"
                          :id="'display_field_' + fieldIndex + '_tab_' + tabIndex + '_element_' + elementIndex"
                        ></b-form-checkbox>
                      </td>
                      <td>
                        <input
                          class="form-control"
                          v-model="field.order"
                          :id="'order_field_' + fieldIndex + '_tab_' + tabIndex + '_element_' + elementIndex"
                          type="number">
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </b-collapse>
              </b-card>
            </b-col>
          </b-collapse>
          <button
            type="button"
            class="btn btn-warning btn-sm"
            @click="addElement(tabIndex)"
          >
            <i class="fa fa-plus mr-2"></i>
            {{ $t('views.externalform.form.addElement') }}
          </button>

        </b-card>

      </b-col>

    </b-row>
    <button
      type="button"
      class="btn d-block"
      @click="addTab()"
    >
      <i class="fa fa-plus mr-2"></i>
      {{ $t('views.externalform.form.addTab') }}
    </button>
    <button type="button" class="btn btn-success" @click="submit()">{{ $t('buttons.submit') }}</button>
  </form>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
// import Trumbowyg from 'vue-trumbowyg'
// import 'trumbowyg/dist/ui/trumbowyg.css'
// import 'trumbowyg/dist/plugins/pasteimage/trumbowyg.pasteimage.min'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import addParamsToQuery from '@/utils/addParamsToQuery'

export default {
  name: 'Form',
  props: ['values', 'initialValues', 'handleSubmit', 'violations'],
  components: {
    ModelSelect
    // Trumbowyg
  },

  data () {
    return {
      initialObject: {},
      isAdvancedSettingsVisible: false,
      emailContentVisible: null,
      tabVisibility: [],
      elementOptions: [
        {
          text: this.$t('views.externalform.form.elementOptions.userDataForm'),
          value: 'userDataForm' // to musi być takie samo jak nazwa obiektu z parametrami formularza (w data) i nazwa obiektu zmiennej językowej
        },
        {
          text: this.$t('views.externalform.form.elementOptions.packageForm'),
          value: 'packageForm'
        },
        {
          text: this.$t('views.externalform.form.elementOptions.consentForm'),
          value: 'consentForm'
        },
        {
          text: this.$t('views.externalform.form.elementOptions.customFieldsForm'),
          value: 'customFieldsForm'
        },
        {
          text: this.$t('views.externalform.form.elementOptions.employeesForm'),
          value: 'employeesForm'
        },
        {
          text: this.$t('views.externalform.form.elementOptions.addressesForm'),
          value: 'addressesForm'
        },
        {
          text: this.$t('views.externalform.form.elementOptions.agreementItemsForm'),
          value: 'agreementItemsForm'
        },
        {
          text: this.$t('views.externalform.form.elementOptions.customForm'),
          value: 'customForm'
        },
        {
          text: this.$t('views.externalform.form.elementOptions.summaryForm'),
          value: 'summaryForm'
        }
      ],
      simpleForms: ['employeesForm', 'addressesForm', 'consentForm', 'agreementItemsForm', 'summaryForm'],
      consentForm: {},
      packageForm: {},
      customFieldsForm: {},
      customForm: {
        title: '',
        htmlContent: ''
      },
      userDataForm: {
        name: {
          label: 'Imię',
          type: 'input',
          display: true,
          order: 1,
          required: true
        },
        surname: {
          label: 'Nazwisko',
          type: 'input',
          display: true,
          order: 2,
          required: true
        },
        userEmail: {
          label: 'Adres e-mail',
          type: 'input',
          display: true,
          order: 3,
          required: true
        },
        pesel: {
          label: 'Numer pesel',
          type: 'input',
          display: true,
          order: 4,
          required: true
        },
        firmname1: {
          label: 'Nazwa firmy',
          type: 'input',
          display: true,
          order: 5,
          required: true
        },
        nip: {
          label: 'Numer nip',
          type: 'input',
          display: true,
          order: 6,
          required: true
        },
        city: {
          label: 'Miasto',
          type: 'input',
          display: true,
          order: 7,
          required: true
        },
        street: {
          label: 'Ulica',
          type: 'input',
          display: true,
          order: 8,
          required: true
        },
        postcode: {
          label: 'Kod pocztowy',
          type: 'input',
          display: true,
          order: 9,
          required: true
        },
        phone: {
          label: 'Telefon',
          type: 'input',
          display: true,
          order: 10,
          required: true
        },
        mobilePhone: {
          label: 'Telefon komórkowy',
          type: 'input',
          display: true,
          order: 8,
          required: true
        },
        regon: {
          label: 'REGON',
          type: 'input',
          display: true,
          order: 11,
          required: true
        },
        krs: {
          label: 'KRS',
          type: 'input',
          display: true,
          order: 12,
          required: true
        }
      },
      trumbowygConfig: {
        semantic: false,
        imageWidthModalEdit: true,
        btnsDef: {
          // Create a new dropdowns
          image: {
            dropdown: ['insertImage'], /*, 'base64' */
            ico: 'insertImage'
          }
        },
        btns: [
          ['viewHTML'],
          ['undo', 'redo'], // Only supported in Blink browsers
          ['formatting'],
          ['strong', 'em', 'del'],
          ['link'],
          ['image'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['unorderedList', 'orderedList'],
          ['horizontalRule']
        ],
        lang: this.$i18n.locale
      }
    }
  },

  watch: {
    listsFetched (val) {
      if (val && this.initialValues) {
        this.handleInitialValues()
      }
    },
    'packages' (val) {
      if (!val) return
      this.packageForm = this.handleDataForForm(val, 'select')
    },
    'customFields' (val) {
      if (!val) return
      this.customFieldsForm = this.handleDataForForm(val, 'custom')
    },
    'consents' (val) {
      if (!val) return
      this.consentForm = this.handleDataForForm(val, 'consents')
    },
    'item.actionForExistingAgreement' (val) {
      if (val === 2) {
        this.item.smsAfter = 1
      }
    }
  },

  beforeDestroy () {
    this.reset()
  },

  computed: {
    listsFetched () {
      return !!(Object.values(this.packageForm).length > 0 && Object.values(this.customFieldsForm).length > 0)
    },

    item () {
      return typeof this.values !== 'undefined' ? this.values : this.initialObject
    },

    isEmailContentVisible: {
      get () {
        return Boolean(this.item.customEmail)
      },
      set (val) {
        this.emailContentVisible = val
      }
    },

    ...mapGetters({
      documentTemplates: 'documenttemplate/list/items',
      packages: 'packages/list/getPackages',
      customFields: 'customfields/list/items',
      getCustomFieldTypeText: 'customfields/list/getCustomFieldTypeText'
    }),

    documentTemplateOptions () {
      return this.documentTemplates.map(entry => {
        return {
          value: entry['@id'],
          text: entry.title
        }
      })
    }
  },

  created () {
    this.getPackages()
    this.getDocumentTemplates()
    this.getCustomFields()
    this.getConsents()
  },

  methods: {
    ...mapMutations({
      reset: 'packages/list/reset'
    }),

    handleInitialValues () {
      this.initialObject = JSON.parse(JSON.stringify(this.initialValues))
      this.initialValues.form.tabs.forEach((tab, tabIndex) => {
        tab.forEach((element, elementIndex) => {
          this.initialObject.form.tabs[tabIndex][elementIndex].selected = element.selected
          this.elementSelected({
            value: element.selected,
            tabIndex: tabIndex,
            elementIndex: elementIndex
          }, true)
          this.setValuesSelected(tabIndex, elementIndex)
        })
      })
      this.initialObject.form.tabs.forEach(entry => {
        this.tabVisibility.push(
          {
            tab: true,
            elements: entry.map(element => true)
          }
        )
      })
    },

    setValuesSelected (tabIndex, elementIndex) {
      if (!this.simpleForms.includes(this.initialObject.form.tabs[tabIndex][elementIndex].selected)) {
        if (this.initialObject.form.tabs[tabIndex][elementIndex].selected === 'customForm') {
          this.initialObject.form.tabs[tabIndex][elementIndex].form = this.initialValues.form.tabs[tabIndex][elementIndex].form
          return
        }
        Object.keys(this.initialObject.form.tabs[tabIndex][elementIndex].form).forEach(key => {
          if (this.initialObject.form.tabs[tabIndex][elementIndex].form[key]) {
            this.initialObject.form.tabs[tabIndex][elementIndex].form[key].display = false
          }
        })
        Object.keys(this.initialValues.form.tabs[tabIndex][elementIndex].form).forEach(key => {
          if (this.initialValues.form.tabs[tabIndex][elementIndex].form[key]) {
            this.initialObject.form.tabs[tabIndex][elementIndex].form[key].display = this.initialValues.form.tabs[tabIndex][elementIndex].form[key].display
            this.initialObject.form.tabs[tabIndex][elementIndex].form[key].required = this.initialValues.form.tabs[tabIndex][elementIndex].form[key].required
          }
        })
      }
    },

    copyObjectToLocalVariable (localObjectName, object) {
      this.$data[localObjectName] = JSON.parse(JSON.stringify(object))
    },

    removeExcessFields (formObject) {
      Object.keys(formObject).forEach(entry => {
        if (formObject[entry].display === false) {
          delete formObject[entry]
        }
      })
    },

    prepareForm (form) {
      form.tabs.forEach(tab => {
        tab.forEach(element => {
          if (element.selected !== 'userDataForm' && element.form) {
            this.removeExcessFields(element.form)
          }
        })
      })
    },

    getSelectedElement (tabIndex, elementIndex) {
      return this.item.form.tabs[tabIndex][elementIndex].selected
    },

    getTypeOfElement (tabIndex, elementIndex) {
      try {
        return Object.values(this.item.form.tabs[tabIndex][elementIndex].form)[0].type
      } catch {
        return 'input'
      }
    },

    handleDataForForm (list, type) {
      let map = new Map()
      if (type === 'custom') {
        list.forEach((entry, index) => {
          map.set(entry.label, {
            label: entry.label,
            type: entry.customFieldType,
            display: Boolean(entry.display),
            order: index + 1,
            required: Boolean(entry.required),
            tooltip: entry.tooltip,
            value: entry['@id'],
            customFieldValues: entry.customFieldValues ? JSON.parse(entry.customFieldValues) : []
          })
        })
      } else if (type === 'consents') {
        list.forEach((entry, index) => {
          map.set(entry.title, {
            label: entry.title,
            type: 'consent',
            display: true,
            order: index + 1,
            required: true,
            value: entry['@id']
          })
        })
      } else {
        list.forEach((entry, index) => {
          map.set(entry.title, {
            label: entry.title,
            type: type,
            display: true,
            order: index + 1,
            required: true,
            value: entry['@id']
          })
        })
      }
      return Object.fromEntries(map)
    },

    submit () {
      let finalObject
      if (this.initialValues) {
        finalObject = JSON.parse(JSON.stringify(this.initialObject))
        this.prepareForm(finalObject.form)
        finalObject.form = JSON.stringify(finalObject.form)
        this.$emit('submit', finalObject)
        return
      }
      finalObject = JSON.parse(JSON.stringify(this.item))
      this.prepareForm(finalObject.form)
      finalObject.form = JSON.stringify(finalObject.form)
      this.$emit('submit', finalObject)
    },

    removeTab (tabIndex) {
      this.item.form.tabs.splice(tabIndex, 1)
    },

    removeElement (tabIndex, elementIndex) {
      this.item.form.tabs[tabIndex].splice(elementIndex, 1)
    },

    addElement (tabIndex) {
      this.item.form.tabs[tabIndex].push(
        {
          hasCustomHtmlContent: 0,
          htmlContent: '',
          selected: '',
          form: {}
        }
      )
    },

    elementSelected (options) {
      if (this.simpleForms.includes(options.value)) {
        delete this.item.form.tabs[options.tabIndex][options.elementIndex].form
        return
      }
      if (!this.initialValues) {
        this.item.form.tabs[options.tabIndex][options.elementIndex].form =
          JSON.parse(JSON.stringify(this.$data[options.value]))
      } else {
        this.initialObject.form.tabs[options.tabIndex][options.elementIndex].form =
          JSON.parse(JSON.stringify(this.$data[options.value]))
      }
      // konwersja do stringa kopiuje obiekt zamiast przekazywać wskaźnik
    },

    toggleElement (tabIndex, elementIndex) {
      this.tabVisibility[tabIndex].elements[elementIndex] = !this.tabVisibility[tabIndex].elements[elementIndex]
      this.$forceUpdate()
    },

    addTab () {
      this.item.form.tabs.push([
        {
          hasCustomHtmlContent: 0,
          htmlContent: '',
          selected: '',
          form: {}
        }
      ])
      this.tabVisibility.push({
        tab: true,
        elements: [
          true
        ]
      })
    },

    toggleTab (index) {
      this.tabVisibility[index].tab = !this.tabVisibility[index].tab
      this.$forceUpdate()
    },

    getDocumentTemplates () {
      let link = addParamsToQuery(
        'document_templates',
        {
          pagination: false,
          templateType: 1
        }
      )
      this.fetchDocumentTemplates(link)
    },

    ...mapActions({
      fetchDocumentTemplates: 'documenttemplate/list/getItems',
      fetchPackages: 'packages/list/fetchPackages',
      fetchCustomFields: 'customfields/list/getItems',
      fetchConsents: 'excmconsent/list/default'
    }),

    getCustomFields () {
      this.fetchCustomFields(
        addParamsToQuery('e_x_a_b_custom_fields', { pagination: false, state: 1 })
      )
    },
    getPackages () {
      this.fetchPackages(
        addParamsToQuery('e_x_a_b_packages', { pagination: false, state: 1 })
      )
    },

    toggleAdvancedFormSetting () {
      this.isAdvancedSettingsVisible = !this.isAdvancedSettingsVisible
    },

    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>

<style scoped>
</style>
